export default {
  notConnected: '钱包未连接',
  connectWallet: '连接钱包',
  connected: '钱包已连接',
  disconnected: '断开连接',
  address: '地址',
  network: '网络',
  status: '状态',
  fullAddress: '完整地址',
  chainId: '链ID',
  connectionTime: '连接时间',
  walletType: '钱包类型',
  copyAddress: '复制地址',
  viewOnChain: '查看链上',
  connectionFailed: '连接失败',
  reconnect: '重新连接',
  disconnect: '断开',
  connectionStatus: {
    connected: '已连接',
    disconnected: '未连接',
    connecting: '连接中',
    error: '连接错误'
  }
};
